import * as Atdgen_codec_runtime from "@ahrefs/bs-atdgen-codec-runtime/src/atdgen_codec_runtime.bs.js";
var write_t = Atdgen_codec_runtime.Encode.make(function (x) {
  if (typeof x === "number") {
    if (x >= 540315116) {
      return Atdgen_codec_runtime.Encode.constr0("HTTP_1_1");
    } else {
      return Atdgen_codec_runtime.Encode.constr0("HTTP_1_0");
    }
  } else {
    return Atdgen_codec_runtime.Encode.constr1("Other", Atdgen_codec_runtime.Encode.string, x[1]);
  }
});
var read_t = Atdgen_codec_runtime.Decode.$$enum(
/* :: */
[
/* tuple */
["HTTP_1_0",
/* `Single */
[-306849112,
/* HTTP_1_0 */
540315115]],
/* :: */
[
/* tuple */
["HTTP_1_1",
/* `Single */
[-306849112,
/* HTTP_1_1 */
540315116]],
/* :: */
[
/* tuple */
["Other",
/* `Decode */
[427938126, function (param) {
  return Atdgen_codec_runtime.Decode.map(function (x) {
    return (
      /* `Other */
      [-912009552, x]
    );
  }, Atdgen_codec_runtime.Decode.string, param);
}]],
/* [] */
0]]]);
export { read_t, write_t };
/* write_t Not a pure module */